// extracted by mini-css-extract-plugin
export default {"header":"cze19au99","whiteStripeContainer":"cevzuvcpd","whiteStripe":"cg9fhfqe6"};